<template>
  <div class="card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h3 class="card-title mb-0">Plan de conturi</h3>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-primary" @click="openAddModal"><i class="bi bi-plus-lg"></i> Adaugă cont</button>
        <button class="btn btn-sm btn-light" @click="reload"><i class="bi bi-arrow-clockwise"></i> Reîncarcă</button>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table id="planConturiTable" class="table table-striped table-bordered w-100">
          <thead>
            <tr>
              <th style="width: 100px;">Cod</th>
              <th>Cod complet</th>
              <th>Descriere</th>
              <th style="width: 90px;">Sold</th>
              <th style="width: 120px;">Tip bilanț</th>
              <th style="width: 90px;">Sursă</th>
            </tr>
          </thead>
          <tbody>
            <!-- Populat de DataTables -->
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Modal Adăugare cont -->
  <div class="modal fade" id="addPlanContModal" tabindex="-1" aria-labelledby="addPlanContLabel" aria-hidden="true" ref="addModalEl">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addPlanContLabel">Adaugă cont în planul de conturi</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closeAddModal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitAdd" @keydown="form.onKeydown($event)">
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label">Cont părinte</label>
                <multiselect
                  ref="parentSelect"
                  v-model="parentSelected"
                  :options="rowsCache"
                  track-by="id"
                  :custom-label="parentLabel"
                  placeholder="— caută sau selectează —"
                  :allow-empty="true"
                  :show-labels="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :internal-search="true"
                  :preserve-search="true"
                  label="descriere"
                  select-label="Selectează"
                  selected-label="Selectat"
                  deselect-label="Șterge"
                />
                <div class="text-muted small">Lasă gol dacă este cont sintetic.</div>
                <div class="invalid-feedback d-block" v-if="form.errors.has('parent_id')" v-html="form.errors.get('parent_id')"></div>
              </div>

              <div class="col-md-4">
                <label class="form-label">ID Client (opțional)</label>
                <input type="number" class="form-control" :class="{'is-invalid': form.errors.has('id_client')}" v-model="form.id_client" placeholder="ex: 1" />
                <div class="invalid-feedback d-block" v-if="form.errors.has('id_client')" v-html="form.errors.get('id_client')"></div>
              </div>

              <div class="col-md-8">
                <label class="form-label">ID Generat (opțional)</label>
                <input type="text" class="form-control" :class="{'is-invalid': form.errors.has('id_generat')}" v-model.trim="form.id_generat" placeholder="ex: 21313 (sufix; dacă nu ai ID client)" />
                <div class="invalid-feedback d-block" v-if="form.errors.has('id_generat')" v-html="form.errors.get('id_generat')"></div>
              </div>

              <div class="col-12">
                <div class="form-text text-muted">
                  Completează <strong>cel puțin unul</strong>: <em>ID Client</em> sau <em>ID Generat</em>. Dacă folosești <em>ID Generat</em>, introdu doar <u>sufixul</u> (ex: 21313) — codul părinte se adaugă automat.
                </div>
              </div>

              <div class="col-12">
                <label class="form-label">Descriere</label>
                <input type="text" class="form-control" :class="{'is-invalid': form.errors.has('descriere')}" v-model.trim="form.descriere" placeholder="ex: Furnizori / Clienți / Venituri..." />
                <div class="invalid-feedback d-block" v-if="form.errors.has('descriere')" v-html="form.errors.get('descriere')"></div>
              </div>

              <div class="col-md-6">
                <label class="form-label">Sold normal</label>
                <select class="form-select" :class="{'is-invalid': form.errors.has('sold_normal')}" v-model="form.sold_normal">
                  <option value="">— necompletat —</option>
                  <option value="debit">Debit</option>
                  <option value="credit">Credit</option>
                </select>
                <div class="invalid-feedback d-block" v-if="form.errors.has('sold_normal')" v-html="form.errors.get('sold_normal')"></div>
              </div>

              <div class="col-md-6">
                <label class="form-label">Tip bilanț</label>
                <select class="form-select" :class="{'is-invalid': form.errors.has('tip_bilant')}" v-model="form.tip_bilant">
                  <option value="">— necompletat —</option>
                  <option value="asset">Activ</option>
                  <option value="liability">Pasiv</option>
                  <option value="equity">Capital</option>
                  <option value="income">Venit</option>
                  <option value="expense">Cheltuială</option>
                  <option value="offbalance">Extrabilanțier</option>
                </select>
                <div class="invalid-feedback d-block" v-if="form.errors.has('tip_bilant')" v-html="form.errors.get('tip_bilant')"></div>
              </div>

              <div class="col-12">
                <div class="form-text">
                  <strong>Notă:</strong> <code>cod_complet</code> se calculează automat (cod + sufix din ID client / ID generat).
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closeAddModal">Închide</button>
          <button type="button" class="btn btn-primary" :disabled="form.busy || (!form.id_client && !form.id_generat)" @click="submitAdd">
            <span v-if="form.busy" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Salvează
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import Multiselect from 'vue-multiselect'

export default {
  name: 'PlanConturi',
  components: { Multiselect },
  data() {
    return {
      dt: null,
      endpoint: '/api/contabilitate/plan_conturi',
      rowsCache: [],
      rowsIndex: {},
      addModal: null,
      form: new Form({
        descriere: '',
        parent_id: null,
        sold_normal: '',
        tip_bilant: '',
        id_client: null,
        id_generat: ''
      }),
      lastFocusEl: null,
      parentSelected: null,
    }
  },
  methods: {
    parentLabel(o) {
      if (!o) return '— fără părinte —'
      const code = o.cod_complet || o.cod || ''
      const desc = o.descriere || ''
      return code ? `${code} — ${desc}` : desc
    },
    async fetchRows() {
      const { data } = await axios.get(this.endpoint)
      // Normalizează datele pentru tabel
      const raw = Array.isArray(data) ? data : []
      this.rowsCache = raw.map(r => ({
        id: r.id,
        parent_id: r.parent_id ?? null,
        cod: r.cod,
        cod_complet: r.cod_complet || r.cod,
        descriere: r.descriere || '',
        sold_normal: r.sold_normal || '',
        tip_bilant: r.tip_bilant || '',
        sursa: r.id_firma === null ? 'sistem' : 'firmă',
      }))
      // construieste un index rapid pentru lookup parinte -> rand
      this.rowsIndex = {}
      this.rowsCache.forEach((r) => { this.rowsIndex[r.id] = r })
    },
    initDataTable() {
      const vm = this
      const $ = window.jQuery || window.$
      if (! $) {
        console.error('jQuery nu este disponibil pentru DataTables.')
        return
      }
      const table = $('#planConturiTable')

      // Daca exista o instanță DT, o distrugem înainte de reinit
      if ($.fn.DataTable.isDataTable(table)) {
        table.DataTable().clear().destroy()
        table.find('tbody').empty()
      }

      this.dt = table.DataTable({
        data: vm.rowsCache,
        columns: [
          { data: 'cod', title: 'Cod',
            render: (data, type, row) => {
              // Daca `cod` este null/vid, afiseaza codul de baza al parintelui (cod sau cod_complet)
              if (data && data !== '') return data
              const parent = vm.rowsIndex && row ? vm.rowsIndex[row.parent_id] : null
              if (parent) {
                return parent.cod || parent.cod_complet || ''
              }
              return ''
            }
          },
          { data: 'cod_complet', title: 'Cod complet' },
          { data: 'descriere', title: 'Descriere' },
          { data: 'sold_normal', title: 'Sold',
            render: (data) => data ? (data === 'debit' ? 'Debit' : 'Credit') : '' },
          { data: 'tip_bilant', title: 'Tip bilanț',
            render: (data) => {
              const map = {
                asset: 'Activ',
                liability: 'Pasiv',
                equity: 'Capital',
                income: 'Venit',
                expense: 'Cheltuială',
                offbalance: 'Extrabilanțier'
              }
              return data ? (map[data] || data) : ''
            } 
          },
          { data: 'sursa', title: 'Sursă',
            render: (data) => data === 'sistem'
              ? '<span class="badge text-bg-secondary">Sistem</span>'
              : '<span class="badge text-bg-primary">Firmă</span>'
          },
        ],
        order: [[0, 'asc']],
        pageLength: 25,
        lengthMenu: [10, 25, 50, 100],
        stateSave: true,
        responsive: true,
        language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
        createdRow: function(row) {
          // Bootstrap 5 styling fix (în caz că e nevoie)
          row.classList.add('align-middle')
        }
      })
    },
    async reload() {
      try {
        await this.fetchRows()
        this.initDataTable()
      } catch (e) {
        console.error('Eroare la reîncărcare plan de conturi:', e)
      }
    },
    openAddModal() {
      // reset erori & formular
      this.form.reset();
      this.parentSelected = null;
      const el = this.$refs.addModalEl;
      // reține elementul care avea focus înainte de deschiderea modalului
      this.lastFocusEl = document.activeElement instanceof HTMLElement ? document.activeElement : null;

      if (window.bootstrap && window.bootstrap.Modal) {
        this.addModal = this.addModal || new window.bootstrap.Modal(el, { focus: true });
        // după ce modalul e afișat, nu mai mutăm focusul automat pe multiselect
        const onShown = () => {
          el.removeEventListener('shown.bs.modal', onShown);
        };
        el.addEventListener('shown.bs.modal', onShown);
        this.addModal.show();
      } else {
        // fallback
        el.classList.add('show');
        el.style.display = 'block';
        // nu mutăm focusul automat
      }
    },
    closeAddModal() {
      const el = this.$refs.addModalEl;

      // dacă focusul este într-un element din modal, elimină focusul înainte de hide
      if (el && el.contains(document.activeElement)) {
        try { (document.activeElement instanceof HTMLElement) && document.activeElement.blur(); } catch (e) {}
      }

      if (this.addModal && this.addModal.hide) {
        // după ce modalul este ascuns complet, refocusează butonul care l-a deschis
        const onHidden = () => {
          el.removeEventListener('hidden.bs.modal', onHidden);
          if (this.lastFocusEl && typeof this.lastFocusEl.focus === 'function') {
            this.lastFocusEl.focus();
          }
        };
        el.addEventListener('hidden.bs.modal', onHidden);
        this.addModal.hide();
      } else {
        // fallback
        el.classList.remove('show');
        el.style.display = 'none';
        if (this.lastFocusEl && typeof this.lastFocusEl.focus === 'function') {
          this.lastFocusEl.focus();
        }
      }
    },
    async submitAdd() {
      // Normalize empty values before submit
      const norm = (v) => (v === '' || v === undefined) ? null : v
      this.form.id_client = norm(this.form.id_client)
      this.form.id_generat = (() => {
        const t = (this.form.id_generat || '').trim()
        return t === '' ? null : t
      })()

      try {
        await this.form.post(this.endpoint)
        this.closeAddModal()
        await this.reload()
      } catch (e) {
        // Erorile de validare sunt gestionate de form.errors
        if (e && e.response && e.response.status === 422 && e.response.data && e.response.data.errors) {
          // vform already populated form.errors; this just helps debug field names
          console.warn('Erori de validare:', this.form.errors.all());
        } else {
          console.error('Eroare la salvare cont:', e)
        }
      }
    },
  },
  watch: {
    parentSelected(newVal) {
      this.form.parent_id = newVal ? newVal.id : null
    }
  },
  async mounted() {
    await this.reload()
    if (window.bootstrap && window.bootstrap.Modal) {
      const el = this.$refs.addModalEl
      if (el) {
        this.addModal = new window.bootstrap.Modal(el)
        // asigură-te că, la ascundere, focusul nu rămâne în interior
        el.addEventListener('hide.bs.modal', () => {
          if (el.contains(document.activeElement)) {
            try { (document.activeElement instanceof HTMLElement) && document.activeElement.blur(); } catch (e) {}
          }
        });
        el.addEventListener('hidden.bs.modal', () => {
          if (this.lastFocusEl && typeof this.lastFocusEl.focus === 'function') {
            this.lastFocusEl.focus();
          }
        });
      }
    }
  },
  beforeUnmount() {
    const $ = window.jQuery || window.$
    const table = $('#planConturiTable')
    if ($ && $.fn.DataTable && $.fn.DataTable.isDataTable(table)) {
      table.DataTable().clear().destroy()
    }
  }
}
</script>

<style scoped>
.dataTables_wrapper .dataTables_filter input {
  width: 220px;
}
.modal .form-label {
  font-weight: 600;
}


  /* ----- vue-multiselect typing color / contrast fixes ----- */
  :deep(.multiselect__input),
  :deep(.multiselect__single),
  :deep(.multiselect__placeholder),
  :deep(.multiselect__tags) {
    color: var(--bs-body-color) !important;
    background-color: var(--bs-body-bg) !important;
  }

  /* Actual input inside tags (when typing) */
  :deep(.multiselect__tags input.multiselect__input) {
    color: var(--bs-body-color) !important;
    caret-color: var(--bs-primary, #3e97ff) !important;
  }

  /* Dropdown panel + options */
  :deep(.multiselect__content-wrapper),
  :deep(.multiselect__content) {
    background-color: var(--bs-body-bg) !important;
    color: var(--bs-body-color) !important;
    border: 1px solid var(--bs-border-color, #e4e6ef) !important;
  }
  :deep(.multiselect__element),
  :deep(.multiselect__option) {
    color: var(--bs-body-color) !important;
  }
  :deep(.multiselect__option--highlight),
  :deep(.multiselect__option--selected) {
    background-color: var(--bs-primary, #3e97ff) !important;
    color: #fff !important;
  }

  /* Dark theme fine-tune, if needed */
  [data-bs-theme="dark"] :deep(.multiselect__tags),
  [data-bs-theme="dark"] :deep(.multiselect__input),
  [data-bs-theme="dark"] :deep(.multiselect__single),
  [data-bs-theme="dark"] :deep(.multiselect__placeholder) {
    background-color: #1e1e2d !important;
    color: #e1e3ea !important;
  }
  [data-bs-theme="dark"] :deep(.multiselect__content-wrapper),
  [data-bs-theme="dark"] :deep(.multiselect__content) {
    background-color: #1e1e2d !important;
    border-color: #2b2b40 !important;
  }


</style>